export const syncMenu = {
	title: "Menu de livraison ({{externalStoreType}})",
	description:
		"Sélectionnez dans la liste de Zig le produit à associer avec l'élément de {{externalStoreType}}. Les éléments deviendront uniques",
	menuNameByExternalType: "Menu de livraison ({{externalStoreType}})",
	entriesLabel: "Entrées",
	emptyTab: "Aucun produit dans cet onglet.",
	emptyState: {
		title: "Aucun produit avec des éléments en attente",
		description:
			"Les produits synchronisés n'ont présenté aucun élément en attente à corriger",
	},
	tabs: {
		synced: "Synchronisés",
		pending: "En attente",
		notSynced: "Non synchronisés",
	},
	syncStatusTag: {
		synced: "Synchronisé",
		pending: "En attente",
		notSynced: "Non synchronisé",
	},
	stepLabel: "Étape {{number}}",
	requiredSuffix: "(obligatoire)",
	correctionSuggested: "{{count}} correction(s) suggérée(s)",
	corrected: "CORRIGÉ",
	improvementSuggested: "{{count}} amélioration(s) suggérée(s)",
	improvementModal: {
		title: "Amélioration suggérée",
		types: {
			name: "Mettre à jour le nom",
			price: "Mettre à jour le prix",
			sku: "Mettre à jour le SKU",
		},
		changeFromTo: 'De "{{current}}" à "{{suggested}}"',
		emptyValue: "(vide)",
		cancel: "Annuler",
		updateAll: "Tout mettre à jour",
	},
	improvementSuccess: {
		title: "Succès !",
		description: "Les suggestions ont été corrigées avec succès !",
	},
	transferProducts: {
		warning:
			"{{amount}} produits n'ont pas été synchronisés. Voulez-vous les importer dans le menu de livraison?",
		description:
			"Sélectionnez les éléments que vous souhaitez importer, ou terminez pour continuer.",
		amountItemsSelected: "<strong>{{amount}}</strong> éléments sélectionnés",
		completeBtn: "Terminer sans importer",
		importItemsBtn: "Importer les éléments",
	},
	notSynced: {
		pendingItems: "{{count}} articles en attente",
		pendingDescription:
			"Aucun SKU similaire n'a été trouvé entre les produits et les compléments à synchroniser. Importez les articles listés pour les gérer dans Zig.",
		itemsSelected: "{{selected}}/{{total}} articles sélectionnés",
		importInfo:
			"Les produits seront importés {{perPage}} par {{perPage}} pour garantir le bon fonctionnement du système",
		importButton: "Importer les articles sélectionnés",
		requiredSuffix: "(Obligatoire)",
		empty: {
			title: "Aucun produit à synchroniser",
			description:
				"Tous les produits ont déjà été importés et synchronisés dans Zig.",
		},
	},
	bindProduct: {
		searchPlaceholder: "Rechercher un autre produit pour synchroniser",
		allProducts: "Tous les produits",
		notProductFound: "Aucun produit trouvé",
		errorProductFound: "Une erreur s'est produite lors de la recherche de produits",
		similarity: {
			title: "Aucun produit similaire trouvé",
			description:
				"Recherchez dans la barre de recherche ci-dessus ou passez au produit suivant.<br/>Vous pourrez importer les produits sans similitude à la fin de la synchronisation.",
		},
		saveLater: "Enregistrer et continuer plus tard",
		undo: "Annuler l'action précédente",
		completeSync: "Terminer la synchronisation",
		skipAll: "Aller au dernier",
		skuInfo: {
			title: "Le SKU de ce produit sera remplacé",
			description:
				"Le SKU de ZIG (produit sélectionné à côté) sera superposé dans les deux menus. C'est cela qui permettra une gestion centralisée.",
		},
		undoModal: {
			title: "Annuler la synchronisation",
			description:
				"Sélectionnez les produits dont vous souhaitez annuler la synchronisation. Vous pouvez les synchroniser à nouveau à tout moment.",
			okText: "Annuler la synchronisation",
			cancelText: "Annuler",
		},
		reImport: "Réimporter le produit",
		reImportLoading: "Réimportation du produit...",
		reImportBlockedDuplicatedSku:
			"Réimportation impossible : ce produit a des compléments avec SKU dupliqué.",
		duplicatedSkuAlert: {
			title: "Réimportation indisponible",
			description:
				"Ce produit a des compléments (ou principal) avec des SKUs dupliqués. Corrigez les SKUs dans iFood avant de réimporter.",
		},
	},
	productCard: {
		descriptionLabel: "Description",
		optionsLabel: "Options",
		syncedSectionsLabel: "Sections synchronisées",
		syncAriaLabel: "Synchroniser",
		active: "Actif",
		inactive: "Inactif",
	},
	transferProductSuccess: {
		title: "Intégration terminée",
		description:
			"Votre intégration est terminée et vos produits ont été synchronisés avec succès!",
		button: "Voir les produits et les menus",
	},
	syncMenuSuccess: {
		title: "Intégration terminée",
		description:
			"Votre intégration est terminée et vos produits ont été synchronisés avec succès!",
		button: "Voir les produits et les menus",
		continue: "Voir les produits non importés",
	},
	errorContent: {
		title: "Impossible d'importer les produits",
		description:
			"Quelque chose de inattendu s'est produit et nous n'avons pas pu terminer l'importation des produits. Terminez votre intégration et finalisez votre menu plus tard.",
		completeBtn: "Terminer la synchronisation sans importer",
		retryBtn: "Réessayer l'importation",
	},
	onboarding: {
		step1: {
			title: "Nous allons afficher un produit à la fois",
			description:
				"Chaque produit importé sera affiché à côté des suggestions équivalentes dans le catalogue de produits de ZIG. Vous sélectionnerez le produit idéal à unifier.",
		},
		step2: {
			title: "Un seul SKU",
			description:
				"En sélectionnant le produit, le SKU de ZIG prévaudra et vous pourrez gérer centralement sur notre tableau de bord.",
		},
		step3: {
			title: "Importez ce qui n'est pas encore dans Zig",
			description:
				"Lorsque vous aurez terminé de synchroniser les articles équivalents, vous pourrez importer les produits qui n'ont pas été identifiés dans le catalogue de ZIG. Ainsi, vous aurez tous vos produits en un seul endroit!",
		},
		skipBtn: "Passer",
		submitBtn: "Commencer la synchronisation",
	},
	completeSyncModal: {
		title: "Terminer la synchronisation",
		text:
			"Eba! Vous avez synchronisé tous les produits!<br/>Voulez-vous annuler la dernière synchronisation ou pouvons-nous terminer cette étape?",
		undoBtn: "Annuler la dernière synchronisation",
		completeBtn: "Terminer l'étape",
	},
};
